type WaitForWindowGlobalOptions = {
    timeoutMs: number;
    pollIntervalMs?: number;
    name?: string;
};

/**
 * Polls until `predicate()` returns a truthy value or the timeout elapses.
 * Use for third-party SDKs whose scripts attach a global at an unpredictable moment
 * (e.g. window.amazon.Pay). For scripts you inject yourself, prefer script.onload.
 */
export const waitForWindowGlobal = <T>(
    predicate: () => T | undefined | null | false,
    { timeoutMs, pollIntervalMs = 200, name = "window global" }: WaitForWindowGlobalOptions
): Promise<T> =>
    new Promise((resolve, reject) => {
        if (typeof window === "undefined") {
            reject(new Error(`Cannot wait for ${name} outside the browser`));
            return;
        }
        const initial = predicate();
        if (initial) {
            resolve(initial as T);
            return;
        }
        const interval = setInterval(() => {
            const value = predicate();
            if (value) {
                clearInterval(interval);
                clearTimeout(timeout);
                resolve(value as T);
            }
        }, pollIntervalMs);
        const timeout = setTimeout(() => {
            clearInterval(interval);
            reject(new Error(`${name} did not load within ${timeoutMs}ms`));
        }, timeoutMs);
    });
